// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1356":"4494c499","3517":"926a06a7","3536":"4494c499","4945":"4494c499"}[chunkId] + ".chunk.css";
};